import React from "react" ;
import { Switch, Route, NavLink } from "react-router-dom";

import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Globals } from "root/DataFunctions/BaseDataFns";
import PostsDashboard from "../Layout/PostsDashboard";
import Published from "../Pages/Published";
import Draft from "../Pages/Draft";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";
import {MessageType} from "root/DataFunctions/Constants";

import "./ChildPosts.scss" ;

const ChildPost = (props) => {
    const postsIconUrl = Globals.BaseURL + "/images/icons/child/article.png";
    const publishedIconUrl = Globals.BaseURL + "/images/icons/child/file.png";
    const draftMsgUrl = Globals.BaseURL + "/images/icons/child/email-draft.png";
    const newIconUrl = Globals.BaseURL + "/images/icons/child/plus.png";
    const pathArray = props.location.pathname.split("/");
    const currentPageName = pathArray[pathArray.length - 1];

    const [renderAddPostModal, showAddPostModal] = useModalAddPost((result) =>
    {
        switch(result){
            case 'saved_create':
                props.history.push('/child/posts/published');
                break;

            case 'saved_draft':
                props.history.push('/child/posts/draft');
                break;
        }
    })

    const clickHandler = (mode, child_uid, post_id) =>
    {
        showAddPostModal(mode, child_uid, post_id, null, MessageType.MESSAGE_TYPE_LIFESTORY);
    }

    return (
        <div className="child-body-content">
            <div className="child-body-content-inner">
                <div className="post-nav">
                    <div className="navigation">
                        <ul>
                            <li onClick={() => clickHandler('create', null, null)}>
                                <NavLink to="#" className="sideNav-link">
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Create Post
                                            </Tooltip>
                                        }
                                    >
                                        <span className="icon">
                                            <img className="img" src={newIconUrl} alt="New icon" />
                                        </span>
                                    </OverlayTrigger>
                                </NavLink>
                            </li>

                            <li 
                                className={currentPageName === '' || currentPageName === 'child' ? "list active" : "list"}
                            >
                                <NavLink to="/child" className="sideNav-link">                      
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Latest Posts
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={postsIconUrl} alt="Posts icon" />
                                        </span>
                                    </OverlayTrigger>
                                </NavLink>
                            </li>
                            
                            <li 
                                className={currentPageName === "published" ? "list active" : "list"}
                            >
                                <NavLink to="/child/posts/published" className="sideNav-link">                      
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                My Sent Posts
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={publishedIconUrl} alt="My posts" />
                                        </span>
                                    </OverlayTrigger>
                                </NavLink>
                            </li>

                            <li 
                                className={currentPageName === "draft" ? "list active" : "list"}
                            >
                                <NavLink to="/child/posts/draft" className="sideNav-link">
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Drafts
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={draftMsgUrl} alt="draft icon" />
                                        </span>
                                    </OverlayTrigger>
                                </NavLink>
                            </li>
                            
                        </ul>
                    </div>
                </div>

                <Switch>
                    <Route path="/child/posts/published" component={Published} />
                    <Route path="/child/posts/draft" component={Draft} />
                    <Route exact path="/child" component={PostsDashboard} />
                </Switch>

            </div>

            {renderAddPostModal()}

        </div>
    );
}

export default ChildPost;
